import firebase from 'firebase/app'
import 'firebase/auth'
import gen from '../gen'

const state = {
  sendPasswordResetEmail_email : ''
}

const getters = {

}

const mutations = {
  //
  resendEmailVerficationLink(state2){
    var user = firebase.auth().currentUser;  //if user logout before exceution of this func, it will return err
    //
    user.sendEmailVerification().then(function() {
      console.log('// Email sent.')
      //
      gen.mutations.snackbar_alert(state, {
        msg:  'A verfication link is sent to your registered email !'
      })
      //
    }).catch(function(error) {
      console.log('// An error happened.')
      //
      gen.mutations.snackbar_alert(state, {
        msg:  error.message
      })
      //
    });
  },
  //
  sendPasswordResetEmail(state2, payload){ //can be used for => change password (in profile)
    //
    var auth = firebase.auth();
    var emailAddress = payload.email

    auth.sendPasswordResetEmail(emailAddress).then(function() {
      console.log('// Email sent.')
      //
      state.sendPasswordResetEmail_email = ''
      //
      gen.mutations.snackbar_alert(state, {
        msg:  'Password reset email sent !'
      })
      //
    }).catch(function(error) {
      console.log('// An error happened.')
      //
      gen.mutations.snackbar_alert(state, {
        msg:  error.message
      })
      //
    });
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/emailPassword_otherFunctions.js